/**
 * Who gets the Property management section in the browser (Listings Phase 5,
 * PM-1). The server decides every read and write on its own
 * (/api/property-management, docs/SECURITY.md "Property management"); this only
 * hides what it would refuse.
 *
 *   section (route + sidebar)  feature:property_management (or _all / _work), or skips checks
 *   every managed property     feature:property_management_all, or skips checks — without
 *                              it the list holds only the properties the user is the
 *                              current Property Manager of (the server filters them)
 *   assign / end management    feature:property_management_work, or skips checks
 *
 * Like useListingsAccess: "skips checks" = useSkipsPermissionChecks (Super Admin or
 * AIG staff), the server's rule for every Property management check.
 */
import { useFeatureAccess } from '@/hooks/useFeatureAccess';
import { useSkipsPermissionChecks } from '@/hooks/useSkipsPermissionChecks';

export function useCanWorkPropertyManagement(): boolean {
  const skips = useSkipsPermissionChecks();
  const hasWork = useFeatureAccess('property_management_work');
  return hasWork || skips;
}

export function useCanSeeAllManagedProperties(): boolean {
  const skips = useSkipsPermissionChecks();
  const hasAll = useFeatureAccess('property_management_all');
  return hasAll || skips;
}

/** The section itself: any of the three keys, or skips checks. */
export function useCanSeePropertyManagement(): boolean {
  const canWork = useCanWorkPropertyManagement();
  const canAll = useCanSeeAllManagedProperties();
  const hasRead = useFeatureAccess('property_management');
  return hasRead || canAll || canWork;
}
